import * as React from "react";
const SvgEmptySelector = (props) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 1, y: 1, width: 30, height: 30, rx: 15, stroke: "#E3E6EE", strokeWidth: 2 }));
export default SvgEmptySelector;
